import angular from "angular";
import { Calculation, CalculationStatus } from "@salaxy/core";
import { WizardController } from "../bases/WizardController";
import { WizardStep, WizardService, InvoicesService, EditDialogParameters } from "../../services";

/**
 * Wizard for creating personal payment.
 */
export class PalkkausPersonalPaymentOverviewController extends WizardController {

  /**
   * For NG-dependency injection
   * @ignore
   */
   public static $inject = ["$scope", "InvoicesService", "EditDialogParameters", "WizardService"];

   /** Used calculation */
  public model: Calculation;

  /**
   * Creates a new WizardController with dependency injection.
   * @ignore
   */
   constructor(
    $scope: angular.IScope,
    private invoices: InvoicesService,
    private editDialogParameters: EditDialogParameters<Calculation>,
    wizardService: WizardService
  ) {
    super($scope, wizardService);
  }

  /**
   * Initialization of the controller
   */
   public $onInit() {
    super.$onInit();

    this.wizardService.setSteps(this.getWizardSteps());
    this.wizardService.activeStepNumber = 1;
    if (!this.editDialogParameters) {
      throw new Error("No editDialogParameters coming in.");
    }
    this.model = this.editDialogParameters.current as Calculation;
    if (this.model?.workflow?.status === CalculationStatus.PaymentSucceeded && !this.editDialogParameters?.logic?.isInspectingPaidInvoices) {
      this.step = 4;
    }
  }

  /** Worker wizard configuration */
  public getWizardSteps(): WizardStep[] {
    if (this.editDialogParameters?.logic?.isInspectingPaidInvoices) {
      return [
        {
          title: "SALAXY.NG1.PalkkausPersonalPaymentOverviewComponent.steps.step1.heading",
          view: "salaxy-components/modals/calc/personal-payment/TotalWorkerPayment.html",
        },
        {
          title: "SALAXY.NG1.PalkkausPersonalPaymentOverviewComponent.steps.step2.heading",
          view: "salaxy-components/modals/calc/personal-payment/Tax.html",
        },
        {
          title: "SALAXY.NG1.PalkkausPersonalPaymentOverviewComponent.steps.step3.heading",
          view: "salaxy-components/modals/calc/personal-payment/SideCosts.html",
        },
      ];
    }
    return [
      {
        title: "SALAXY.NG1.PalkkausPersonalPaymentOverviewComponent.steps.step1.heading",
        view: "salaxy-components/modals/calc/personal-payment/TotalWorkerPayment.html",
      },
      {
        title: "SALAXY.NG1.PalkkausPersonalPaymentOverviewComponent.steps.step2.heading",
        view: "salaxy-components/modals/calc/personal-payment/Tax.html",
      },
      {
        title: "SALAXY.NG1.PalkkausPersonalPaymentOverviewComponent.steps.step3.heading",
        view: "salaxy-components/modals/calc/personal-payment/SideCosts.html",
      },
      {
        title: "SALAXY.NG1.PalkkausPersonalPaymentOverviewComponent.steps.step4.heading",
        view: "salaxy-components/modals/calc/personal-payment/Approval.html",
      },
    ];
  }

  /** Returns true if user can go forward in  the wizard  */
  public get canGoNext(): boolean {
    if (this.steps.length > this.step) {
      if (this.steps[this.step] && !this.steps[this.step].disabled) {
          return true;
      }
    }
    return false;
  }

  /**
   * Navigates to the next step if possible.
   * Override adds the taxcard if personalId is there and resets it if personalId has changed.
   */
   public goNext() {
    super.goNext();
  }

  /**
   * Checks if user can navigate to previuous step
   */
  public get canGoPrevious(): boolean {
    if (this.model?.workflow?.status === CalculationStatus.PaymentSucceeded && !this.editDialogParameters?.logic?.isInspectingPaidInvoices) {
      return false;
    }

    if (this.step > 1 && !this.steps[this.step - 2].disabled) {
        return true;
    }
    return false;
}

  /**
   * Return EPR payment warning to template
   */
  public get eprPaymentWarning() {
    return this.invoices.getEprWarningForPayment(this.model?.workflow?.salaryDate);
  }

  /**
   * Return EPR cancel warning to template
   */
   public get eprCancelWarning() {
    return this.invoices.getEprWarningForCancellation(this.model?.workflow?.salaryDate, this.model?.workflow?.status === CalculationStatus.PaymentSucceeded ? true : false);
  }
}